import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import { AbsolutePositioned } from '../../../components/Layout/AbsolutePositioned';
import { ContentContainer } from '../../../components/Layout/ContentContainer';
import { Screen } from '../../../components/Layout/Screen';
import Title, { Highlight } from '../../../components/Title';
import Timeline from '../../../components/Timeline';

// Assets
import { brandColors, device } from '../../../styles/variables';
import methodology from '../../../assets/images/pages/services/methodology_image.png';

const StyledScreen = Screen.extend`
  background: ${brandColors.white};
`;

const BackgroundOverlay = AbsolutePositioned.extend`
  background: url(${methodology}) no-repeat;
  background-size: contain;
  background-position: 50%;
`;

const TitleContainer = styled.div`
  margin: 154px 0 0 0;
`;

const TimelineContainer = styled.div`
  .NumberContainer,
  .TimelineContent {
    float: none;
  }

  .NumberContainer {
    margin-top: 73px;
    width: fit-content;

    @media ${device.tablet} {
      width: fit-content;
      margin-top: 70px;
    }
    @media ${device.laptopL} {
      width: auto;
    }
  }

  .TimelineContent {
    margin: 0;
    @media ${device.tablet} {
      margin: 72px 0 0 0;
    }
    h2 {
      width: 301px;
      font-weight: bold;
      text-align: left;
      font-size: 32px;
      line-height: 42px;
      @media ${device.tablet} {
        line-height: 70px;
        font-size: 60px;
        width: 645px;
      }
      @media ${device.laptop} {
        width: 702px;
      }
    }
  }
`;

const Manifesto = () => (
  <StyledScreen>
    <BackgroundOverlay bottom="0" right="0" />
    <ContentContainer>
      <TitleContainer>
        <Title className="title" primary={false}>
          Our agile methodology is how we&apos;re different:
        </Title>
      </TitleContainer>
      <TimelineContainer>
        <Timeline
          numberColor={brandColors.blue}
          timelineId="manifestoTimeline"
          automatic
          dotMarkers
          lineLength="xlarge"
        >
          <TimelineContainer timelineStep="01">
            <Title primary={false}>
              Individuals and interactions <Highlight>over</Highlight> processes and tools
            </Title>
          </TimelineContainer>
          <TimelineContainer timelineStep="02">
            <Title primary={false}>
              Working software <Highlight>over</Highlight> comprehensive documentation
            </Title>
          </TimelineContainer>
          <TimelineContainer timelineStep="03">
            <Title primary={false}>
              Customer collaboration <Highlight>over</Highlight> contract negotiation
            </Title>
          </TimelineContainer>
          <TimelineContainer timelineStep="04">
            <Title primary={false}>
              Responding to change <Highlight>over</Highlight> following a plan
            </Title>
          </TimelineContainer>
        </Timeline>
      </TimelineContainer>
    </ContentContainer>
  </StyledScreen>
);

export default connect()(Manifesto);



// WEBPACK FOOTER //
// ./src/pages/Services/screens/Manifesto.jsx